<!-- eslint-disable no-irregular-whitespace -->
<template>
<div class="g-doc">
    <div class="table-of-contents">
      <ul>
        <li><a href="#fsmeeting">FSMeeting(主要接口类)</a>
          <ul>
            <li><a href="#shared">shared</a></li>
            <li><a href="#printversion">printVersion</a></li>
            <li><a href="#setclientinfo">setClientInfo</a></li>
            <li><a href="#entermeetingwithroomidparam">enterMeetingWithRoomIDParam</a></li>
            <li><a href="#entermeetingwithusernameparam">enterMeetingWithUserNameParam</a></li>
            <li><a href="#entermeetingwithtokenparam">enterMeetingWithTokenParam</a></li>
            <li><a href="#isfsmeetingactive">isFSMeetingActive</a></li>
            <li><a href="#isfsmeetingminimize">isFSMeetingMinimize</a></li>
            <li><a href="#hadsuccessconfigsdkinfo">hadSuccessConfigSdkInfo</a></li>
            <li><a href="#setmeetingscene">setMeetingScene</a></li>
            <li><a href="#setminimizeblock">setMinimizeBlock</a></li>
            <li><a href="#sethangupblock">setHangupBlock</a></li>
            <li><a href="#maximizewindow">maximizeWindow</a></li>
            <li><a href="#minimizewindow">minimizeWindow</a></li>
            <li><a href="#exitmeetingroom">exitMeetingRoom</a></li>
            <li><a href="#setmicrophoneenabled">setMicrophoneEnabled</a></li>
            <li><a href="#setcameraenabled">setCameraEnabled</a></li>
            <li><a href="#setshareblock">setShareBlock</a></li>
            <li><a href="#supportedinterfaceorientations">supportedInterfaceOrientations</a></li>
          </ul>
        </li>
        <li><a href="#data-definitions">数据结构定义</a>
          <ul>
            <li><a href="#fsmeetingscenetype">FSMeetingSceneType</a></li>
            <li><a href="#fsmeetinglogintype">FSMeetingLoginType</a></li>
            <li><a href="#fsmeetinglogouttype">FSMeetingLogoutType</a></li>
            <li><a href="#entermeetingbaseparam">EnterMeetingBaseParam</a></li>
            <li><a href="#entermeetingwithroomidparam-data">EnterMeetingWithRoomidParam</a></li>
            <li><a href="#entermeetingwithusernameparam-data">EnterMeetingWithUserNameParam</a></li>
            <li><a href="#entermeetingwithtokenparam-data">EnterMeetingWithTokenParam</a></li>
            <li><a href="#sharemeetinginfoobj">ShareMeetingInfoObj</a></li>
          </ul>
        </li>
      </ul>
    </div>
    <div id="right" class="content-right">
      <h1 class="curproject-name">iOS 3.36.11.11</h1>

      <!-- ==================== FSMeeting ==================== -->
      <h1 id="fsmeeting">FSMeeting(主要接口类)</h1>

      <!-- shared -->
      <h2 id="shared">shared</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>单例初始化</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">+ (instancetype)shared;</code></pre>

      <!-- printVersion -->
      <h2 id="printversion">printVersion</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>打印sdk 版本号 相关信息</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)printVersion;</code></pre>

      <!-- setClientInfo -->
      <h2 id="setclientinfo">setClientInfo</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置配置信息</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>NSString clientId</td><td></td><td>clientID</td></tr>
          <tr><td>NSString secret</td><td></td><td>secret</td></tr>
          <tr><td>NSString ip</td><td></td><td>会议服务器ip</td></tr>
          <tr><td>NSString port</td><td></td><td>会议服务端口</td></tr>
          <tr><td>UIViewController fatherVc</td><td></td><td>宿主UIViewController</td></tr>
          <tr><td>BOOL isShowHud</td><td></td><td>是否显示loading</td></tr>
          <tr><td>result block</td><td></td><td>设置结果回调</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">-(void)setClientInfo:(NSString *)clientId secret:(NSString*)secret <br>
        serverip:(NSString *)ip serverport:(NSString *)port viewCtrl:(UIViewController*)fatherVc <br>
        isShowHud:(BOOL)isShowHud result:(void(^)(BOOL isSuccess)) result;</code></pre>

      <!-- enterMeetingWithRoomIDParam -->
      <h2 id="entermeetingwithroomidparam">enterMeetingWithRoomIDParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>通过RoomID 直接进入会议室</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>EnterMeetingWithRoomidParam param</td><td></td><td>入会参数对象</td></tr>
          <tr><td>loginBlock</td><td></td><td>登录代码块</td></tr>
          <tr><td>logoutBlock</td><td></td><td>退会代码块</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">-(void)enterMeetingWithRoomIDParam:(EnterMeetingWithRoomidParam *)param <br>
        loginBlock:(void(^)(FSMeetingLoginType type, ReturnCode code))<br>
        loginBlock logoutBlock:(void(^)(FSMeetingLogoutType type))logoutBlock;</code></pre>

      <!-- enterMeetingWithUserNameParam -->
      <h2 id="entermeetingwithusernameparam">enterMeetingWithUserNameParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>直接进入视频会议界面，或者会议室列表界面</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>EnterMeetingWithUserNameParam param</td><td></td><td>入会参数对象</td></tr>
          <tr><td>loginBlock</td><td></td><td>登录代码块</td></tr>
          <tr><td>logoutBlock</td><td></td><td>退会代码块</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">-(void)enterMeetingWithUserNameParam:(EnterMeetingWithUserNameParam *)param <br>
        loginBlock:(void(^)(FSMeetingLoginType type, ReturnCode code))<br>
        loginBlock logoutBlock:(void(^)(FSMeetingLogoutType type))logoutBlock;</code></pre>

      <!-- enterMeetingWithTokenParam -->
      <h2 id="entermeetingwithtokenparam">enterMeetingWithTokenParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>直接进入视频会议界面，或者会议室列表界面</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>EnterMeetingWithTokenParam param</td><td></td><td>入会参数对象</td></tr>
          <tr><td>loginBlock</td><td></td><td>登录代码块</td></tr>
          <tr><td>logoutBlock</td><td></td><td>退会代码块</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">-(void)enterMeetingWithTokenParam:(EnterMeetingWithTokenParam *)param <br>
        loginBlock:(void(^)(FSMeetingLoginType type, ReturnCode code))loginBlock <br>
        logoutBlock:(void(^)(FSMeetingLogoutType type))logoutBlock;</code></pre>

      <!-- isFSMeetingActive -->
      <h2 id="isfsmeetingactive">isFSMeetingActive</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>是否处于会议室中</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">-(BOOL)isFSMeetingActive;</code></pre>

      <!-- isFSMeetingMinimize -->
      <h2 id="isfsmeetingminimize">isFSMeetingMinimize</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>是否已最小化</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (BOOL)isFSMeetingMinimize;</code></pre>

      <!-- hadSuccessConfigSdkInfo -->
      <h2 id="hadsuccessconfigsdkinfo">hadSuccessConfigSdkInfo</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>是否设置了IP，端口，clientID,secret</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">-(BOOL)hadSuccessConfigSdkInfo;</code></pre>

      <!-- setMeetingScene -->
      <h2 id="setmeetingscene">setMeetingScene</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置会议室场景</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>FSMeetingSceneType type</td><td></td><td>纯音频/音视频/会议</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)setMeetingScene:(FSMeetingSceneType)type;</code></pre>

      <!-- setMinimizeBlock -->
      <h2 id="setminimizeblock">setMinimizeBlock</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置窗口最小最小化回调</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>minimizeBlock</td><td></td><td>最小化回调</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)setMinimizeBlock:(void(^)(FSMeetingSceneType))minimizeBlock;</code></pre>

      <!-- setHangupBlock -->
      <h2 id="sethangupblock">setHangupBlock</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置挂断回调</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>hangupBlock</td><td></td><td>挂断回调</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)setHangupBlock:(void(^)(FSMeetingSceneType))hangupBlock;</code></pre>

      <!-- maximizeWindow -->
      <h2 id="maximizewindow">maximizeWindow</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置窗口最大化</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>UIViewController fatherViewCtl</td><td></td><td>present 会中界面的父视图(传入nil则使用入会参数的fatherVc)</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)maximizeWindow:(UIViewController *)fatherViewCtl;</code></pre>

      <!-- minimizeWindow -->
      <h2 id="minimizewindow">minimizeWindow</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置窗口最小化</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)minimizeWindow;</code></pre>

      <!-- exitMeetingRoom -->
      <h2 id="exitmeetingroom">exitMeetingRoom</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>退出会议室</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)exitMeetingRoom;</code></pre>

      <!-- setMicrophoneEnabled -->
      <h2 id="setmicrophoneenabled">setMicrophoneEnabled</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>开关麦克风</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>BOOL enabled</td><td></td><td>0:关闭 1:开启</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)setMicrophoneEnabled:(BOOL)enabled;</code></pre>

      <!-- setCameraEnabled -->
      <h2 id="setcameraenabled">setCameraEnabled</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>开关摄像头</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>BOOL enabled</td><td></td><td>0:关闭 1:开启</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)setCameraEnabled:(BOOL)enabled;</code></pre>

      <!-- setShareBlock -->
      <h2 id="setshareblock">setShareBlock</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>设置分享回调</code></pre>
      <h3>请求参数</h3>
      <table>
        <thead>
          <tr><th>参数名称</th><th>示例</th><th>备注</th></tr>
        </thead>
        <tbody>
          <tr><td>shareBlock</td><td></td><td>分享回调</td></tr>
        </tbody>
      </table>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (void)setShareBlock:(void(^)(UIViewController *fatherVC, ShareMeetingInfoObj *shareInfo))shareBlock;</code></pre>

      <!-- supportedInterfaceOrientations -->
      <h2 id="supportedinterfaceorientations">supportedInterfaceOrientations</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>支持屏幕旋转方向</code></pre>
      <h3>请求参数</h3>
      <h3>方法声明</h3>
      <pre><code class="language-objectivec">- (UIInterfaceOrientationMask)supportedInterfaceOrientations;</code></pre>

      <!-- ==================== 数据结构定义 ==================== -->
      <h1 id="data-definitions">数据结构定义</h1>

      <!-- FSMeetingSceneType -->
      <h2 id="fsmeetingscenetype">FSMeetingSceneType</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>会议室场景类型枚举</code></pre>
      <table>
        <thead>
          <tr><th>枚举值</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>FSMeetingSceneTypeMeeting</td><td>会议模式</td></tr>
          <tr><td>FSMeetingSceneTypePureAudio</td><td>1对1纯音频模式</td></tr>
          <tr><td>FSMeetingSceneTypeAudioVideo</td><td>1对多音视频模式</td></tr>
        </tbody>
      </table>

      <!-- FSMeetingLoginType -->
      <h2 id="fsmeetinglogintype">FSMeetingLoginType</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>登录类型枚举</code></pre>
      <table>
        <thead>
          <tr><th>枚举值</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>FSMeetingLoginTypeStart</td><td>登录开始</td></tr>
          <tr><td>FSMeetingLoginTypeFail</td><td>登录失败</td></tr>
          <tr><td>FSMeetingLoginTypeCompleted</td><td>登录完成</td></tr>
        </tbody>
      </table>

      <!-- FSMeetingLogoutType -->
      <h2 id="fsmeetinglogouttype">FSMeetingLogoutType</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>退会类型枚举</code></pre>
      <table>
        <thead>
          <tr><th>枚举值</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>FSMeetingLogoutTypeTimeout</td><td>等待超时退会，入会参数param.timeoutEnabled必须设置为YES</td></tr>
          <tr><td>FSMeetingLogoutTypeHangupBeforeMeeting</td><td>会前挂断</td></tr>
          <tr><td>FSMeetingLogoutTypeCallEnded</td><td>剩自己为最后一人时自动退会，入会参数param.singleExit必须设置为YES</td></tr>
          <tr><td>FSMeetingLogoutTypeLocalHangup</td><td>本地挂断/退会</td></tr>
          <tr><td>FSMeetingLogoutTypeNetworkException</td><td>网络异常</td></tr>
          <tr><td>FSMeetingLogoutTypeKickedOut</td><td>被请出会议室</td></tr>
          <tr><td>FSMeetingLogoutTypeMeetingEnded</td><td>结束会议退会</td></tr>
          <tr><td>FSMeetingLogoutTypeAPI</td><td>使用SDK接口退会</td></tr>
        </tbody>
      </table>

      <!-- EnterMeetingBaseParam -->
      <h2 id="entermeetingbaseparam">EnterMeetingBaseParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>入会基础参数类</code></pre>
      <table>
        <thead>
          <tr><th>属性名称</th><th>类型</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>microphoneEnabled</td><td>BOOL</td><td>入会后自动打开麦克风</td></tr>
          <tr><td>cameraEnabled</td><td>BOOL</td><td>入会后自动打开摄像头</td></tr>
          <tr><td>hangupButtonDisabled</td><td>BOOL</td><td>是否禁用挂断按钮</td></tr>
          <tr><td>microphoneButtonDisabled</td><td>BOOL</td><td>是否禁用麦克风按钮</td></tr>
          <tr><td>cameraButtonDisabled</td><td>BOOL</td><td>是否禁用摄像头按钮</td></tr>
          <tr><td>ringEnabled</td><td>BOOL</td><td>其他人员未入会前是否播放铃声，默认不播放</td></tr>
          <tr><td>timeoutEnabled</td><td>BOOL</td><td>30秒无人入会，则自动退会</td></tr>
          <tr><td>calling</td><td>BOOL</td><td>是否主动呼叫</td></tr>
          <tr><td>roomid</td><td>NSString</td><td>会议室ID</td></tr>
          <tr><td>fatherVc</td><td>UIViewController</td><td>宿主UIViewController</td></tr>
          <tr><td>audioMode</td><td>NSInteger</td><td>0:扬声器[默认扬声器] 1:听筒</td></tr>
          <tr><td>imgUrl</td><td>NSString</td><td>默认图片Url</td></tr>
          <tr><td>calledUserName</td><td>NSString</td><td>被呼叫用户昵称</td></tr>
        </tbody>
      </table>

      <!-- EnterMeetingWithRoomidParam -->
      <h2 id="entermeetingwithroomidparam-data">EnterMeetingWithRoomidParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>通过会议室ID入会参数类，继承自EnterMeetingBaseParam</code></pre>
      <table>
        <thead>
          <tr><th>属性名称</th><th>类型</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>rpwd</td><td>NSString</td><td>会议室密码，若有则可填入</td></tr>
          <tr><td>nickName</td><td>NSString</td><td>昵称，可随意填但不能为空，进入会议室后将显示</td></tr>
        </tbody>
      </table>

      <!-- EnterMeetingWithUserNameParam -->
      <h2 id="entermeetingwithusernameparam-data">EnterMeetingWithUserNameParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>通过用户名密码入会参数类，继承自EnterMeetingBaseParam</code></pre>
      <table>
        <thead>
          <tr><th>属性名称</th><th>类型</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>userName</td><td>NSString</td><td>会议室用户名</td></tr>
          <tr><td>pwd</td><td>NSString</td><td>密码</td></tr>
        </tbody>
      </table>

      <!-- EnterMeetingWithTokenParam -->
      <h2 id="entermeetingwithtokenparam-data">EnterMeetingWithTokenParam</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>通过Token入会参数类，继承自EnterMeetingBaseParam</code></pre>
      <table>
        <thead>
          <tr><th>属性名称</th><th>类型</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>userCode</td><td>NSString</td><td>用户名code</td></tr>
          <tr><td>token</td><td>NSString</td><td>token</td></tr>
        </tbody>
      </table>

      <!-- ShareMeetingInfoObj -->
      <h2 id="sharemeetinginfoobj">ShareMeetingInfoObj</h2>
      <h3>基本信息</h3>
      <p><strong>接口描述：</strong></p>
      <pre><code>分享会议信息对象类</code></pre>
      <table>
        <thead>
          <tr><th>属性名称</th><th>类型</th><th>描述</th></tr>
        </thead>
        <tbody>
          <tr><td>enableInvite</td><td>BOOL</td><td>是否开启邀请码入会</td></tr>
          <tr><td>hopeStartTime</td><td>NSString</td><td>预约开始时间</td></tr>
          <tr><td>hopeEndTime</td><td>NSString</td><td>预约结束时间</td></tr>
          <tr><td>hopeTZCode</td><td>NSString</td><td>预约会议时区</td></tr>
          <tr><td>inviteCode</td><td>NSString</td><td>邀请码</td></tr>
          <tr><td>roomId</td><td>NSInteger</td><td>会议室ID</td></tr>
          <tr><td>roomName</td><td>NSString</td><td>会议室名称</td></tr>
          <tr><td>roomType</td><td>NSString</td><td>1.固定会议室 2.预约会议室 4.周例会议室</td></tr>
          <tr><td>creatorDisplayName</td><td>NSString</td><td>会议创建人昵称</td></tr>
          <tr><td>meetingURL</td><td>NSString</td><td>会议链接</td></tr>
          <tr><td>weekStartTime</td><td>NSString</td><td>每周会议开始时间</td></tr>
          <tr><td>weekEndTime</td><td>NSString</td><td>每周会议结束时间</td></tr>
          <tr><td>cycleFlag</td><td>NSString</td><td>周例循环模式(1 每天 2每周 3每月 只有 roomType 为4时，才有效)</td></tr>
          <tr><td>weeks</td><td>NSString</td><td>周循环周(0-6 周一-周日 多个用,隔开 只有 roomType 为 4，cycleFlag 为 2 时才有效)</td></tr>
          <tr><td>phoneMeetingRight</td><td>NSInteger</td><td>电话会议权限</td></tr>
          <tr><td>dateEveyMonth</td><td>NSString</td><td>周循环 某日(只有roomType为4，cycleFlag 为 3 时才有效)</td></tr>
        </tbody>
      </table>

      
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped src="./index.css"></style>
<style scoped>

 .table-of-contents {
    position: absolute;
    height: calc(100% - 50px);
    top: 50px;
    left: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    width: 375px;
}
</style>